import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BillboardRoutingModule } from './billboard-routing.module';
import { BillboardComponent } from './billboard/billboard.component';
import { RingComponent } from './components/ring/ring.component';
import { BeltComponent } from './components/belt/belt.component';
import { LiveComponent } from './live/live.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
	declarations: [
		BillboardComponent,
		RingComponent,
		BeltComponent,
		LiveComponent
	],
	imports: [CommonModule, BillboardRoutingModule, SharedModule]
})
export class BillboardModule {}
